import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import { setAlert } from "../../../../action/alert";
import Alert from "../../../layout/Alert";
import AppButton from "../../../Common/Button/Button";
import FormInput from "../../../Common/FormInputs/MuiTextField";
import DataTable from "../../../Common/DataTable/DataTable";
import { SectionHeading } from "../../../Common/Typography/AppTypography";
import { format } from "date-fns";
import { dacStatsPageSize } from "../DACStatisticsConstants";

const DeviceDACLogs = ({
    deviceDetails,
    dacData = [],
    getDeviceDACLogsData,
    showSearch = false,
    showCount = false
}) => {
    const [deviceDACLogsData, setDeviceDACLogsData] = useState([]);
    const [updateFlag, setUpdateFlag] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [macAddress, setMacAddress] = useState("");

    const headers = {
        serialNumber: "S.No",
        timestamp: 'Created At'
    };

    useEffect(() => {
        if (deviceDetails && deviceDetails instanceof Object && deviceDetails.hasOwnProperty('macAddress')) {
            getDeviceDACLogs()
        }
    }, [deviceDetails])

    useEffect(() => {
        if (updateFlag) {
            getDeviceDACLogs()
        }
    }, [updateFlag])

    useEffect(() => {
        setDeviceDACLogsData(Array.isArray(dacData) ? dacData : [])
    }, [dacData])

    const filter = () => {
        setUpdateFlag(Math.random());
    }

    const getNextPage = () => {
        const newPg = pageIndex + 1
        setPageIndex(newPg);
        setIsLoading(true)
        getDeviceDACLogsData({
            macAddress,
            pgIndex: newPg,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }

    const getPrevPage = () => {
        const newPg = pageIndex - 1;
        setPageIndex(newPg);
        setIsLoading(true)
        getDeviceDACLogsData({
            macAddress,
            pgIndex: newPg,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }

    const getDeviceDACLogs = () => {
        setIsLoading(true)
        getDeviceDACLogsData({ macAddress: deviceDetails?.macAddress ?? "" }, () => {
            setIsLoading(false);
        })
    }

    const searchDACLogs = () => {
        setIsLoading(true)
        setPageIndex(0);
        getDeviceDACLogsData({
            macAddress,
            pgIndex: 0,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }

    const deviceDACLogColumns = Object.keys(headers).map((key) => ({
        key,
        label: headers[key],
        minWidth: key === "timestamp" ? 220 : 100,
        cellSx: { wordBreak: "break-word", whiteSpace: "normal" }
    }));

    const logsArray = Array.isArray(deviceDACLogsData) ? deviceDACLogsData : [];
    const deviceDACLogRows = logsArray.map((element, index) => ({
        rowId: `${element}-${index}`,
        serialNumber: index + 1,
        timestamp: format(new Date(Number(element)), "dd MMM yyyy, hh:mm a")
    }));

    return (
        <Fragment>
            {showSearch && (
                <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
                    <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", alignItems: { xs: "stretch", sm: "center" }, gap: { xs: 1.5, sm: 2 } }}>
                        <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 200px" }, minWidth: 0, maxWidth: { xs: "100%", sm: 320 }, width: { xs: "100%", sm: "auto" } }}>
                            <FormInput
                                type="text"
                                size="small"
                                placeholder="Enter MAC address"
                                value={macAddress}
                                onChange={(e) => setMacAddress(e.target.value)}
                                startAdornment={<SearchIcon />}
                                sx={{ width: "100%" }}
                            />
                        </Box>
                        <AppButton
                            variant="primary"
                            size="medium"
                            onClick={() => searchDACLogs()}
                            disabled={macAddress === ""}
                            sx={{ minWidth: 80, height: 40, width: { xs: "100%", sm: "auto" } }}
                        >
                            Filter
                        </AppButton>
                    </Box>
                </Paper>
            )}
            <Alert />

            {isLoading ? (
                <Box sx={{ display: "grid", placeItems: "center", height: "80vh" }}>
                    <CircularProgress sx={{ color: "#AFB42B" }} size={60} />
                </Box>
            ) : (
                <Box sx={{ width: "100%", minWidth: 0 }}>
                    {showCount && (
                        <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
                            <SectionHeading sx={{ m: 0 }}>
                                DAC Count : {Array.isArray(dacData) ? dacData.length : "-"}
                            </SectionHeading>
                        </Paper>
                    )}
                    <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, overflow: "hidden" }}>
                        <DataTable
                            columns={deviceDACLogColumns}
                            data={deviceDACLogRows}
                            rowKey="rowId"
                            minWidth="100%"
                            msgForDisplay="No Data found"
                            sx={{
                                width: "100%",
                                minWidth: 0,
                                overflowX: "auto",
                            }}
                            tableContainerSx={{
                                width: { xs: "100%", sm: "max-content" },
                                maxWidth: "100%",
                                minWidth: { xs: 0, sm: "100%" },
                                boxShadow: "none",
                            }}
                        />
                    </Paper>
                </Box>
            )}
        </Fragment>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    setCustomAlert: (message, alertType) => dispatch(setAlert(message, alertType))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDACLogs);
